/* eslint-disable no-restricted-imports */
import React, { useEffect, useState } from "react";
// import SVG from "react-inlinesvg";
import { getDashboardData } from "../modules/Auth/_redux/dashboardCrud";
import { toAbsoluteUrl } from "../../_metronic/_helpers";import {
  InputLabel,
  Button,
  RadioGroup,
  Radio,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export function DashboardPage() {
  const Styles = {
    box30Container: {
      display: "inline-block",
      width: "30%",
      marginRight: "12px",
      verticalAlign: "top"
    },
    box70Container: {
      display: "inline-block",
      width: "calc(70% - 12px)",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    box70Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      fontSize: "1.2rem",
      marginBottom: "12px",
      fontWeight: "bold",
      color: "#555555"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    dataCol30Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      width: "30%",
      height: "44px"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem"
      //   marginLeft: "12px"
    },
  };

  const [systemInfo, setSystemInfo] = useState(null);
  const [polling, setPolling] = useState(false);

  const [queueDeffered, setQueueDeffered] = useState(0);
  const [queueIncoming, setQueueIncoming] = useState(0);
  const [queueCorrupt, setQueueCorrupt] = useState(0);
  const [queueActive, setQueueActive] = useState(0);
  const [queueHold, setQueueHold] = useState(0);

  const [totalUserCount, setTotalUserCount] = useState(0);
  const [overUserCount, setOverUserCount] = useState(0);

  const [statIncoming, setStatIncoming] = useState(0);
  const [statOutgoing, setStatOutgoing] = useState(0);
  const [versionZimbra, setVersionZimbra] = useState("");

  const [statusAmavis, setStatusAmavis] = useState("Running");
  const [statusAntispam, setStatusAntispam] = useState("Running");
  const [statusImapd, setStatusImapd] = useState("Running");
  const [statusMailbox, setStatusMailbox] = useState("Running");
  const [statusLdap, setStatusLdap] = useState("Running");
  const [statusMta, setStatusMta] = useState("Running");

  const [showPanel, setShowPanel] = useState(false);

  const formatBytes = (bytes = 0, fixed) => {
    const marker = 1024; // Change to 1000 if required
    const decimal = fixed != null ? fixed : 2; // Change as required
    const kiloBytes = marker; // One Kilobyte is 1024 bytes
    const megaBytes = marker * marker; // One MB is 1024 KB
    const gigaBytes = marker * marker * marker; // One GB is 1024 MB
    // const teraBytes = marker * marker * marker * marker; // One TB is 1024 GB

    // return bytes if less than a KB
    if (bytes == null || bytes < kiloBytes) {
      return `${bytes}B`;
      // return KB if less than a MB
    }
    if (bytes < megaBytes) {
      return `${(bytes / kiloBytes).toFixed(decimal)}KB`;
      // return MB if less than a GB
    }
    if (bytes < gigaBytes) {
      return `${(bytes / megaBytes).toFixed(decimal)}MB`;
      // return GB if less than a TB
    }

    return `${(bytes / gigaBytes).toFixed(decimal)}GB`;
  };

  const pollDashboard = () => {
    // if (!polling) return;

    getDashboardData().then(dashboard => {
      console.log("DASHBOARD", dashboard);
      setSystemInfo(dashboard.data.systemInfo);

      // QUEUE 처리
      if (dashboard.data.queueInfo != null)
        dashboard.data.queueInfo[0].queue.forEach(queue => {
          if (queue.name === "deferred") setQueueDeffered(queue.n);
          if (queue.name === "incoming") setQueueIncoming(queue.n);
          if (queue.name === "corrupt") setQueueCorrupt(queue.n);
          if (queue.name === "active") setQueueActive(queue.n);
          if (queue.name === "hold") setQueueHold(queue.n);
        });

      // QUOTA 처리
      let totalUser = 0;
      let overuseUser = 0;
      if (dashboard.data.quotaUsage != null) {
        dashboard.data.quotaUsage.forEach(quota => {
          totalUser += 1;
          if (quota.limit !== 0 && quota.limit >= quota.user) overuseUser += 1;
        });
      }

      setTotalUserCount(totalUser);
      setOverUserCount(overuseUser);

      //   @Description("Number of messages delivered to mailboxes as a result of LMTP delivery")
      //   private static final String DC_LMTP_DLVD_MSGS = "lmtp_dlvd_msgs";
      //   @Description("Number of IMAP requests received")
      //   private static final String DC_IMAP_COUNT = "imap_count";
      //   @Description("Average processing time (ms) of IMAP requests")
      //   private static final String DC_IMAP_MS_AVG = "imap_ms_avg";
      //   @Description("Number of POP3 requests received")
      //   private static final String DC_POP_COUNT = "pop_count";
      if (dashboard.data.serverStats != null) {
        dashboard.data.serverStats.forEach(stat => {
          if (stat.name === "lmtp_dlvd_msgs")
            setStatOutgoing(parseInt(stat._content, 10));
          if (stat.name === "mbox_add_msg_count")
            setStatIncoming(parseInt(stat._content));
        });
      }

      // buildDate: "20211124-1752"
      // host: "${zimbra.server.hostname}"
      // majorversion: "8"
      // microversion: "15"
      // minorversion: "8"
      // platform: "@@BUILD_PLATFORM@@"
      // release: "root"
      // type: "FOSS"
      // version: "8.8.15_GA.FOSS"
      if (dashboard.data.versionInfo != null) {
        dashboard.data.versionInfo.forEach(info => {
          setVersionZimbra(info.version + " " + info.buildDate);
        });
      }

      //   amavis                  Running
      //   antispam                Running
      //   imapd                   Running
      //   ldap                    Running
      //   logger                  Running
      //   mailbox                 Running
      //   memcached               Running
      //   mta                     Running
      //   opendkim                Running
      //   proxy                   Running
      //   service webapp          Running
      //   stats                   Running
      //   zimbra webapp           Running
      //   zimbraAdmin webapp      Running
      //   zimlet webapp           Running
      //   zmconfigd               Running

      if (dashboard.data.zmstat != null) {
        dashboard.data.zmstat.forEach(line => {
          if (line.indexOf("Host") >= 0) {
            console.log("ZMSTAT HOST", line.split(" ")[1]);
          } else {
            let aline = line.replaceAll("\t", "");
            let status = "";

            if (aline.indexOf("amavis") >= 0) {
              status = aline.substr("amavis".length).trim();
              setStatusAmavis(status);
              console.log("XX amavis", status);
            }
            if (aline.indexOf("antispam") >= 0) {
              status = aline.substr("antispam".length).trim();
              setStatusAntispam(status);
              console.log("XX antispam", status);
            }

            if (aline.indexOf("imapd") >= 0) {
              status = aline.substr("imapd".length).trim();
              setStatusImapd(status);
              console.log("XX imapd", status);
            }

            if (aline.indexOf("mailbox") >= 0) {
              status = aline.substr("mailbox".length).trim();
              setStatusMailbox(status);
              console.log("XX mailbox", status);
            }

            if (aline.indexOf("ldap") >= 0) {
              status = aline.substr("ldap".length).trim();
              setStatusLdap(status);
              console.log("XX ldap", status);
            }

            if (aline.indexOf("mta") >= 0) {
              status = aline.substr("mta".length).trim();
              setStatusMta(status);
              console.log("XX mta", status);
            }

            // console.log(aline);
          }
        });
      }
    })
    .catch(error => {
      console.log(error)
    })

    // setTimeout(() => {
    //   pollDashboard();
    // }, 5000);
  };

  useEffect(() => {
    // setPolling(true);
    // pollDashboard();

    // return () => {
    //   setPolling(false);
    // };
  }, []);

  return (
    <>
      <div
        style={{
          marginTop: "12px",
          marginLeft: "-12px",
          height: "100%"
        }}
      >
        {/* -------------------- */}
        <div style={Styles.box30Container}>
          <div style={Styles.box30Style}>
            <div style={Styles.subTitleStyle}>
              서비스 상태
              {/* <div
                style={{
                  display: "inline-block",
                  float: "right",
                  fontWeight: "normal",
                  fontSize: "1rem",
                  marginTop: "4px",
                  borderBottom: "solid",
                  borderBottomWidth: "1px"
                }}
                onClick={() => setShowPanel(true)}
              >
                상세보기
              </div> */}
            </div>
            <div style={Styles.headerRowStyle}>
              <div style={Styles.headerColStyle}>서비스 명</div>
              <div style={Styles.headerColStyle}>상태</div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>Core Engine</div>
              <div style={Styles.dataColStyle}>
                <img
                  src={toAbsoluteUrl(
                    statusMailbox === "Running"
                      ? "/media/images/led-blue.svg"
                      : "/media/images/led-red.svg"
                  )}
                  alt=""
                  style={{ marginRight: "8px" }}
                />
                {statusMailbox}
              </div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>SMTP/LMTP</div>
              <div style={Styles.dataColStyle}>
                <img
                  src={toAbsoluteUrl(
                    statusMta === "Running"
                      ? "/media/images/led-blue.svg"
                      : "/media/images/led-red.svg"
                  )}
                  alt=""
                  style={{ marginRight: "8px" }}
                />
                {statusMta}
              </div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>IMAP</div>
              <div style={Styles.dataColStyle}>
                <img
                  src={toAbsoluteUrl(
                    statusImapd === "Running"
                      ? "/media/images/led-blue.svg"
                      : "/media/images/led-red.svg"
                  )}
                  alt=""
                  style={{ marginRight: "8px" }}
                />
                {statusImapd}
              </div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>Amavis Anti Virus</div>
              <div style={Styles.dataColStyle}>
                <img
                  src={toAbsoluteUrl(
                    statusAmavis === "Running"
                      ? "/media/images/led-blue.svg"
                      : "/media/images/led-red.svg"
                  )}
                  alt=""
                  style={{ marginRight: "8px" }}
                />
                {statusAmavis}
              </div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>Spam Assassin</div>
              <div style={Styles.dataColStyle}>
                <img
                  src={toAbsoluteUrl(
                    statusAntispam === "Running"
                      ? "/media/images/led-blue.svg"
                      : "/media/images/led-red.svg"
                  )}
                  alt=""
                  style={{ marginRight: "8px" }}
                />
                {statusAntispam}
              </div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>LDAP</div>
              <div style={Styles.dataColStyle}>
                <img
                  src={toAbsoluteUrl(
                    statusLdap === "Running"
                      ? "/media/images/led-blue.svg"
                      : "/media/images/led-red.svg"
                  )}
                  alt=""
                  style={{ marginRight: "8px" }}
                />
                {statusLdap}
              </div>
            </div>
          </div>

          {/* -------------------- */}
          <div style={Styles.box30Style}>
            <div style={Styles.subTitleStyle}>시스템 현황</div>
            <div style={Styles.headerRowStyle}>
              <div style={Styles.headerColStyle}>항목</div>{" "}
              <div style={Styles.headerColStyle}>상태</div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>NETWORK</div>{" "}
              <div style={Styles.dataColSmallStyle}>
                {formatBytes(systemInfo?.networkData[0].tx_bytes)} Tx
                <br />
                {formatBytes(systemInfo?.networkData[0].rx_bytes)} Rx
              </div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>CPU</div>{" "}
              <div style={Styles.dataColStyle}>
                {systemInfo == null
                  ? 0
                  : Math.ceil(systemInfo?.loadData.avgLoad * 100)}
                %{" "}
              </div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>MEMORY</div>{" "}
              <div style={Styles.dataColStyle}>
                {systemInfo == null
                  ? 0
                  : Math.ceil(
                      ((systemInfo?.memData.total -
                        systemInfo?.memData.available) /
                        systemInfo?.memData.total) *
                        100
                    )}
                %
              </div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>DISK</div>{" "}
              <div style={Styles.dataColStyle}>
                {systemInfo == null ? 0 : systemInfo?.fsSizeData[0].use}%
              </div>
            </div>
          </div>

          {/* -------------------- */}
          <div style={Styles.box30Style}>
            <div style={Styles.subTitleStyle}>큐 상태</div>
            {/* <div style={Styles.headerRowStyle}>
            <div style={Styles.headerColStyle}>서비스 명</div>{" "}
            <div style={Styles.headerColStyle}>상태</div>
          </div> */}

            {/* queueInfo: Array(1)
            0:
            name: "mail.brainary.io"
            queue: Array(5)
            0: {name: 'deferred', n: '0'}
            1: {name: 'incoming', n: '0'}
            2: {name: 'corrupt', n: '0'}
            3: {name: 'active', n: '0'}
            4: {name: 'hold', n: '0'} */}

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>DEFFERED</div>{" "}
              <div style={Styles.dataColStyle}>{queueDeffered}</div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>INCOMING</div>{" "}
              <div style={Styles.dataColStyle}>{queueIncoming}</div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>ACTIVE</div>{" "}
              <div style={Styles.dataColStyle}>{queueActive}</div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>HELD</div>{" "}
              <div style={Styles.dataColStyle}>{queueHold}</div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>CURRUPT</div>{" "}
              <div style={Styles.dataColStyle}>{queueCorrupt}</div>
            </div>
          </div>
        </div>

        <div style={Styles.box70Container}>
          <div style={Styles.box70Style}>
            <div style={Styles.subTitleStyle}>메일 QUOTA 초과 현황</div>
            <div style={Styles.headerRowStyle}>
              <div style={Styles.headerColStyle}>도메인 명</div>
              <div style={Styles.headerColStyle}>총량</div>
              <div style={Styles.headerColStyle}>초과 사용자</div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>BRAINARY.IO</div>
              <div style={Styles.dataColStyle}>무제한</div>
              <div style={Styles.dataColStyle}>{overUserCount}</div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>BITSCHOIR.COM</div>
              <div style={Styles.dataColStyle}>무제한</div>
              <div style={Styles.dataColStyle}>{overUserCount}</div>
            </div>
          </div>

          <div style={Styles.box70Style}>
            <div style={Styles.subTitleStyle}>계정 현황</div>
            <div style={Styles.headerRowStyle}>
              <div style={Styles.headerColStyle}>도메인 명</div>
              <div style={Styles.headerColStyle}>할당</div>
              <div style={Styles.headerColStyle}>활성화</div>
              <div style={Styles.headerColStyle}>초과사용자</div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>BRAINARY.IO</div>
              <div style={Styles.dataColStyle}>무제한</div>
              <div style={Styles.dataColStyle}>{totalUserCount}</div>
              <div style={Styles.dataColStyle}>{overUserCount}</div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>BITSCHOIR.COM</div>
              <div style={Styles.dataColStyle}>무제한</div>
              <div style={Styles.dataColStyle}>{totalUserCount}</div>
              <div style={Styles.dataColStyle}>{overUserCount}</div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>총계</div>
              <div style={Styles.dataColStyle}>무제한</div>
              <div style={Styles.dataColStyle}>{totalUserCount}</div>
              <div style={Styles.dataColStyle}>{overUserCount}</div>
            </div>
          </div>

          <div style={Styles.box70Style}>
            <div style={Styles.subTitleStyle}>메일 통계</div>
            <div style={Styles.headerRowStyle}>
              <div style={Styles.headerColStyle}>도메인 명</div>
              <div style={Styles.headerColStyle}>합계</div>
              <div style={Styles.headerColStyle}>Inbound</div>
              <div style={Styles.headerColStyle}>Outbound</div>
              {/* <div style={Styles.headerColStyle}>Local</div>
              <div style={Styles.headerColStyle}>Remote</div> */}
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>BRAINARY.IO</div>
              <div style={Styles.dataColStyle}>
                {statIncoming + statOutgoing}
              </div>
              <div style={Styles.dataColStyle}>{statIncoming}</div>
              <div style={Styles.dataColStyle}>{statOutgoing}</div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>BITSCHOIR.COM</div>
              <div style={Styles.dataColStyle}>
                {statIncoming + statOutgoing}
              </div>
              <div style={Styles.dataColStyle}>{statIncoming}</div>
              <div style={Styles.dataColStyle}>{statOutgoing}</div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataColStyle}>총계</div>
              <div style={Styles.dataColStyle}>
                {statIncoming + statOutgoing}
              </div>
              <div style={Styles.dataColStyle}>{statIncoming}</div>
              <div style={Styles.dataColStyle}>{statOutgoing}</div>
            </div>
          </div>

          {/* -------------------- */}
          <div style={Styles.box30Style}>
            <div style={Styles.subTitleStyle}>제품 및 설치 정보</div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataCol30Style}>Host Name</div>{" "}
              <div style={Styles.dataColTextStyle}>
                mail.brainary.io, 210.89.190.197
              </div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataCol30Style}>메일/백신/스팸 엔진 버전</div>{" "}
              <div style={Styles.dataColTextStyle}>{versionZimbra}</div>
            </div>
            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataCol30Style}>KISA RBL 업데이트</div>{" "}
              <div style={Styles.dataColTextStyle}>2024.01.01 04:00:00</div>
            </div>

            {/* <div style={Styles.dataRowStyle}>
              <div style={Styles.dataCol30Style}>백신 버전</div>{" "}
              <div style={Styles.dataColTextStyle}>
                Zimbra Anti Virus 8.8.12
              </div>
            </div>

            <div style={Styles.dataRowStyle}>
              <div style={Styles.dataCol30Style}>스팸 버젼</div>{" "}
              <div style={Styles.dataColTextStyle}>
                Zimbra Spam Assasin Amavis 8.8.12
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <Dialog
        open={showPanel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        
        <DialogContent>
        <div style={{ width: "480px", padding: "24px" }}>
          <div style={Styles.subTitleStyle}>서비스 상태</div>
          <div style={Styles.headerRowStyle}>
            <div style={Styles.headerColStyle}>서비스 명</div>
            <div style={Styles.headerColStyle}>상태</div>
            <div style={Styles.headerColStyle}>사용/중지</div>
          </div>

          <div style={Styles.dataRowStyle}>
            <div style={Styles.dataColStyle}>Core Engine</div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/led-blue.svg"
                    : "/media/images/led-red.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              {statusMailbox}
            </div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_use.svg"
                    : "/media/images/btn_use.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_stop.svg"
                    : "/media/images/btn_stop.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
            </div>
          </div>

          <div style={Styles.dataRowStyle}>
            <div style={Styles.dataColStyle}>SMTP/LMTP</div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusMta === "Running"
                    ? "/media/images/led-blue.svg"
                    : "/media/images/led-red.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              {statusMta}
            </div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_use.svg"
                    : "/media/images/btn_use.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_stop.svg"
                    : "/media/images/btn_stop.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
            </div>
          </div>
          
          <div style={Styles.dataRowStyle}>
            <div style={Styles.dataColStyle}>IMAP</div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusImapd === "Running"
                    ? "/media/images/led-blue.svg"
                    : "/media/images/led-red.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              {statusImapd}
            </div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_use.svg"
                    : "/media/images/btn_use.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_stop.svg"
                    : "/media/images/btn_stop.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
            </div>
          </div>

          <div style={Styles.dataRowStyle}>
            <div style={Styles.dataColStyle}>Amavis Anti Virus</div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusAmavis === "Running"
                    ? "/media/images/led-blue.svg"
                    : "/media/images/led-red.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              {statusAmavis}
            </div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_use.svg"
                    : "/media/images/btn_use.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_stop.svg"
                    : "/media/images/btn_stop.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
            </div>
          </div>
          <div style={Styles.dataRowStyle}>
            <div style={Styles.dataColStyle}>Spam Assassin</div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusAntispam === "Running"
                    ? "/media/images/led-blue.svg"
                    : "/media/images/led-red.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              {statusAntispam}
            </div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_use.svg"
                    : "/media/images/btn_use.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_stop.svg"
                    : "/media/images/btn_stop.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
            </div>
          </div>
          <div style={Styles.dataRowStyle}>
            <div style={Styles.dataColStyle}>LDAP</div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusLdap === "Running"
                    ? "/media/images/led-blue.svg"
                    : "/media/images/led-red.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              {statusLdap}
            </div>
            <div style={Styles.dataColStyle}>
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_use.svg"
                    : "/media/images/btn_use.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
              <img
                src={toAbsoluteUrl(
                  statusMailbox === "Running"
                    ? "/media/images/btn_stop.svg"
                    : "/media/images/btn_stop.svg"
                )}
                alt=""
                style={{ marginRight: "8px" }}
              />
            </div>
          </div>
        </div>
        </DialogContent>

        <DialogActions>
          <div
            style={{ width: "100%", textAlign: "center", paddingBottom: "8px" }}
          >
            <Button
              className={Styles.buttonSmallStyle}
              onClick={() => {
                setShowPanel(false);
              }}
            >
              취소
            </Button>

          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
